import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const Moon9pm = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00003 12.7499C10.6234 12.7499 12.75 10.6233 12.75 7.99997C12.75 5.37663 10.6234 3.25 8.00003 3.25C5.37669 3.25 3.25006 5.37663 3.25006 7.99997C3.25006 10.6233 5.37669 12.7499 8.00003 12.7499ZM8.00003 13.9999C11.3137 13.9999 14 11.3137 14 7.99997C14 4.68628 11.3137 2 8.00003 2C4.68634 2 2.00006 4.68628 2.00006 7.99997C2.00006 11.3137 4.68634 13.9999 8.00003 13.9999Z"
        fill="currentColor"
      />
      <path
        d="M14 7.99997C14 11.0048 11.8976 13.4407 9.30432 13.4407C6.711 13.4407 4.6087 11.0048 4.6087 7.99994C4.6087 4.99507 6.711 2.55914 9.30432 2.55914C11.8976 2.55914 14 4.9951 14 7.99997Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.30432 12.1907C11.0408 12.1907 12.75 10.4936 12.75 7.99997C12.75 5.5063 11.0408 3.80914 9.30432 3.80914C7.56783 3.80914 5.8587 5.50627 5.8587 7.99994C5.8587 10.4936 7.56783 12.1907 9.30432 12.1907ZM9.30432 13.4407C11.8976 13.4407 14 11.0048 14 7.99997C14 4.9951 11.8976 2.55914 9.30432 2.55914C6.711 2.55914 4.6087 4.99507 4.6087 7.99994C4.6087 11.0048 6.711 13.4407 9.30432 13.4407Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default Moon9pm;
